import { render } from "./ImageShow.vue?vue&type=template&id=9dd469c6&scoped=true"
import script from "./ImageShow.vue?vue&type=script&lang=js"
export * from "./ImageShow.vue?vue&type=script&lang=js"

import exportComponent from "H:\\ideaProject\\vue\\fiveG-project\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dd469c6"]])

export default __exports__